import React from 'react';
import {StyledPrimaryActionButton} from "./PrimaryActionButton.styled";

interface PrimaryActionButtonProps {
    onClick: () => void;
    disabled?: boolean;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    children?: React.ReactNode;
}

const PrimaryActionButton = ({
    onClick,
    disabled = false,
    startIcon,
    endIcon,
    children,
}: PrimaryActionButtonProps) => {
    return (
        <StyledPrimaryActionButton
            variant="contained"
            startIcon={startIcon ?? <></>}
            endIcon={endIcon ?? <></>}
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </StyledPrimaryActionButton>
    );
};

export default PrimaryActionButton;